export function CourseForumEmptyIllustration() {
  return (
    <div className="lms-course-forum-empty-state__graphic" aria-hidden="true">
      <svg className="lms-course-forum-empty-state__svg" fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <rect fill="currentColor" fillOpacity="0.12" height="20" rx="4" width="28" x="6" y="8" />
        <path d="M10 15H26M10 19H20" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
        <rect fill="currentColor" fillOpacity="0.2" height="20" rx="4" width="28" x="14" y="20" />
        <path d="M18 27H34M18 31H28" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
        <circle cx="36" cy="14" fill="currentColor" r="2.5" />
      </svg>
      <span className="material-symbols-outlined lms-course-forum-empty-state__badge">chat</span>
    </div>
  );
}
